export enum LegendColors {

    // Antibiotic colors, that are used in the report, but not listed in the macro
    Amoxicillin = '#264d99',
    Cefotaxime = '#ced943',
    Ceftiofur = '#8064a2',
    Colistin = '#000000',
    Florfenicol = '#ffc000',
    Neomycin = '#4c5f27',
    Spectinomycin = '#ced0d2',
    Sulphamethoxazole = '#f06b0a',
    Tiamulin = '#ffc000',
    Tilmicosin = '#9bbb59',
    Tulathromycin = '#76933c',

    // RGB codes copied and converted to hex codes
    // Basis stofgrupper (basic substance groups)
    "3rd gen. cephalosporin" = '#8064a2',
    "Ampicillin" = '#8db4e2',
    "Ceftazidime" = '#8064a2',
    "Cefuroxime" = '#b1a0c7',
    "Ciprofloxacin" = '#e60a0a',
    "Erythromycin" = '#ced943',
    "Gentamicin" = '#9bbb59',
    "Meropenem" = '#16365c',
    "Penicillin" = '#c5d9f1',
    "Piperacillin/tazobactam" = '#264d99',
    "Quinupristin/Dalfopristin" = '#a6a6a6',
    "Quinupristin/dalfopristin" = '#a6a6a6',
    "Streptomycin" = '#76933c',
    "Sulfonamide" = '#f06b0a',
    "Tetracycline" = '#852405',
    "Trimethoprim" = '#ffbf8f',

    // Detalje stofgrupper (detail substance groups)
    "3. generation cephalosporin"  = '#8064a2',
    "Aminoglycosides" = '#8db4e2',
    "Aminoglycosides (J01GB)" = '#264d99',
    "Amoxicillin (J01CA04)" = '#16365c',
    "Amoxicillin and enzyme inhibitor (J01CR02)" = '#538dd5',
    "Amphenicols" = '#000000',
    "Azithromycin" = '#4c5f27',
    "Beta-lactam. resis. penicillins  (J01CF)" = '#8db4e2',
    "Beta-lactam. sens. penicillins  (J01CE)" = '#c5d9f1',
    "Beta-lactamase sensitive penicillins (J01CE)" = '#c5d9f1',
    "Carbapenems" = '#ffcc00',
    "Cephalosporins" = '#e60a0a',
    "Cephalosporins (J01DB, DC, DD)" = '#e60a0a',
    "Chloramphenicol" = '#ffc400',
    "Colistin (local GI)" = '#264d99',
    "Combinations of penicillins, including beta-lactamase inhibitors (J01CR)" = '#ced943',
    "Dicloxacillin (J01CF01)" = '#b1a0c7',
    "Doxycycline (J01AA02)" = '#538dd5',
    "Flucloxacillin (J01CF05)" = '#b1a0c7',
    "Fluoroquinolones" = '#ced943',
    "Fluoroquinolones (J01MA)" = '#ced943',
    "High-level gentamicin" = '#4f6228',
    //"Lincosamides" = '#974706',
    "Lymecycline (J01AA04)" = '#8db4e2',
    "Macrolides" = '#c5d9f1',
    "Macrolides (J01FA)" = '#c5d9f1',
    "Nitrofuran deriv." = '#538dd5',
    "Other AB" = '#9bbb59',
    "Other antibacterials" = '#9bbb59',
    "Penicillin/streptomycin" = '#ff9646',
    "Penicillins (broad-spectrum)" = '#c5d9f1',
    "Penicillins (narrow-spectrum)" = '#ff9646',
    "Penicillins with extend. spectrum (J01CA)" = '#c5d9f1',
    "Penicillins with extended spectrum (J01CA)" = '#c5d9f1',
    "Penicillins, beta-lact. sen" = '#ff9646',
    "Penicillin's,  b-lactamase sensitive" = '#ff9646',
    "Penicillins, b-lact. sen. (d)" = '#ff9646',
    "Penicillin's,  others(a)" = '#538ed5',
    "Penicillins, other" = '#538ed5',
    "Phenoxymethylpenicillin (J01CE02)" = '#997300',
    "Pivampicillin (J01CA02)" = '#9bbb59',
    "Pivmecillinam (J01CA08)" = '#c5d9f1',
    "Pleuromutilins" = '#ff9646',
    "Sulfonam./trimeth." = '#f06b0a',
    "Sulfonamides and trimethoprim(b)" = '#f06b0a',
    "Sulfonamides and trimethoprim (J01E)" = '#f06b0a',
    "Tetracycline (J01AA07)" = '#8db4e2',
    "Tetracyclines" = '#853f05',
    "Tetracyclines (J01AA)" = '#8db4e2',
    "Zn" = '#4f6228',
    "ZnO" = '#9abb59',

    // Fund (finding)
    "4,[5],12:i:-" = '#9abb59',
    "AmpC enzymes" = '#77b13c',
    "AmpC Phenotype" = '#77b13c',
    "CARB-2" = '#e60a0a',
    "CMY-2" = '#77b13c',
    "CPE" = '#e60a0a',
    "CTX-M-1" = '#538ed5',
    "CTX-M-14" = '#8db5e2',
    "CTX-M-55" = '#c5d9f1',
    "Salmonella Derby" = '#8db5e2',
    "ESBL and AmpC enzymes" = '#31869b',
    "ESBL enzymes" = '#8db5e2',
    "ESBL phenotype" = '#8db5e2',
    "ESBL-AmpC phenotype" = '#31869b',
    "Salmonella Infantis" = '#ffc08f',
    "Lincosamides" = '#a6a6a6',
    "Lincosamides  (c)" = '#a6a6a6',
    "Salmonella Livingstone" = '#f06b0a',
    "Salmonella London" = '#60497a',
    "Not available" = '#a6a6a6',
    "Salmonella Not typeable" = '#a6a6a6',
    "Other Phenotype" = '#bfbfbf',
    "Other serovar" = '#c5d9f1',
    "SHV-12" = '#ff9646',
    "SHV-2" = '#f06b0a',
    "SHV-28" = '#ffc08f',
    "Suspect" = '#bfbfbf',
    "TEM-52B" = '#8064a2',
    "TEM-84" = '#b1a0c7',
    "Salmonella Typhimurium" = '#77b13c',
    "Unspecified" = '#a6a6a6',
    "Up-reg. ampC" = '#9bbb59',
    "Fully sensitve" = '#9bbb59',
    "Resistant" = '#ff9646',
    "Multi-resistant" = '#f06b0a',

    // Kategorier (animal category)
    "Abattoir workers 1997" = '#264d99',
    "Admissions" = '#538ed5',
    "Aquaculture" = '#8db5e2',
    "All age groups, adjusted" = '#e60a0a',
    "Bed-days" = '#9abb59',
    "Blood DK" = '#264c99',
    "Broilers" = '#f06b0a',
    "Broiler meat - Danish" = '#b15307',
    "Broiler meat - Import" = '#753705',
    "Cattle" = '#9abb59',
    "DDD/1000 inh./day" = '#9abb59',
    "DDD/1000 inhabitants" = '#779306',
    "Domestic cases" = '#b1a0c7',
    "Domestically acquired" = '#b1a0c7',
    "Finishers" = '#538ed5',
    "Fur animals" = '#8064a2',
    "Healthy human volunteers from the community" = '#b15307',
    "Horses" = '#31869b',
    "Hospital care" = '#99cc33',
    "Intramammary treatment of cattle" = '#779306',
    "Number of positive bloodisolates" = '#ffcc00',
    "Nurses 1997" = '#e60a0a',
    "Packages/1000 inh./year" = '#538ed5',
    "Pets" = '#b1a0c7',
    "Pig producers 1997" = '#ff9966',
    "Pigs" = '#538ed5',
    "Pork" = '#8db5e2',
    "Pigs produced" = '#f06b0a',
    "Poultry" = '#f06b0a',
    "Prescriptions/1000 inhabitants" = '#8db5e2',
    "Primary health care" = '#3366cc',
    "Recruits 1997 and 2008" = '#ffcc99',
    "Sows and piglets" = '#8db5e2',
    "Systemic treatment of cattle" = '#9abb59',
    "Systemic treatment of pigs" = '#538ed5',
    "Total, adjusted" = '#e60a0a',
    "Travel cases" = '#8064a2',
    "Travel associated" = '#8064a2',
    "Treated pat./1000 inh./year" = '#e26b0a',
    "Urine GP DK" = '#c5d9f1',
    "Urine Hospitals DK" = '#538ed5',
    "Users/1000 inhabitants" = '#ffcc00',
    "Weaners" = '#c5d9f1',
    "Reproduction/urogenital" = '#ffcc00',
    "Udder" = '#e26b0a',
    "GastrointestinaI" = '#9abb59',
    "Respiratory" = '#8064a2',
    "Joints/limbs/skin" = '#538ed5',
    //"Unspecified" = '',
    "Metabolism, digestion, circulation" = '#c5d9f1',
}

export const LegendFallbackColors = [
    '#003f5c',
    '#58508d',
    '#bc5090',
    '#ff6361',
    '#77bebf',
    '#63c6a4',
    '#82c670',
    '#bbbe32',
    '#980087',
    '#ca0078',
    '#f01662',
    '#ff4b48',
    '#ff7a26',
    "#ffa900",
    "#fcd500",
    "#dcff04",
]